import { fg } from '@atlassian/jira-feature-gating';
import { useShouldShowOnboardingKanbanTour } from '@atlassian/jira-onboarding-quickstart-core/src/services/index.tsx';
import type { ModalSource } from './types.tsx';

export const useCanShowNudgeTour = () => {
	const [shouldShowOnboardingKanbanTour] = useShouldShowOnboardingKanbanTour();

	return (source: ModalSource) => {
		switch (source) {
			case 'board':
				return shouldShowOnboardingKanbanTour;
			case 'timeline':
				// display if eligible for either board/backlog scenarios
				return shouldShowOnboardingKanbanTour;
			case 'list':
				if (fg('jira_onboarding_wizard_m1_feature_gate')) {
					return true;
				}
				return false;
			default:
				return false;
		}
	};
};
